import { useState } from "react"
import { contactoApi } from "../../api/contactoApi"
import { agentesApi } from "../../api/agentesApi"
import { categoriaAgenteApi } from "../../api/categoriaAgenteApi"
import { materialApoyoApi } from "../../api/materialApoyoApi"
import {extraerCatalogoDeColeccion}  from '@utils'
import { ResultadosApis } from "../../api/moduloResultados/ResultadosApi"
import { productosAgenteApi } from "../../api/productosAgenteApi"
import { comprasApi } from "../../api/comprasApi"
import { schemaFormFactoryApi } from "../../api/schemaFormFactoryApi"
import { permisosApi } from "../../api/sistema/permisosApi"
import { rutasApi } from "../../api/sistema/rutasApi"
import { usuarioApi } from "../../api/usuarioApi"
import { tiposUsuarioApi } from "../../api/sistema/tiposUsuarioApi"
import { reporteAxaApi } from "../../api/bots/reporteAxaApi"
import { reporteSISEApi } from "../../api/bots/reporteSISE"
import { reportePrimaPagadaApi } from "../../api/bots/reportePrimaPagada"
import { noticiasApi } from "../../api/noticiasApi"
import { videosApi } from "../../api/videosApi"
import { comentariosApi } from "../../api/comentariosApi"

/*Params types
    params = {
        seleccion: 'nombreDelCatalogo'
    }
*/

export const useCatalogo = (params) => {

  const getApiActiva = () => {
    switch (params.seleccion) {
      case "reportePrimaPagada":
        return reportePrimaPagadaApi
          break
        case "videos":
          return videosApi
            break
        case "comentarios":
          return comentariosApi
            break
        case "noticias":
          return noticiasApi
            break
      case "reporteSISE":
        return reporteSISEApi
          break
      case "agentes":
        return agentesApi
          break
      case "contacto":
        return contactoApi
          break
      case "categoriasAgente":
        return categoriaAgenteApi
          break
      case "materialApoyo":
        return materialApoyoApi
          break
      case "insignias":
        return ResultadosApis.insigniaApi
          break
      case "nivel":
        return ResultadosApis.nivelApi
      case "nivelActividad":
        return ResultadosApis.nivelActividadApi
          break
      case "companias":
        return ResultadosApis.companiasApi
          break
      case "eventos":
        return ResultadosApis.eventosApi
          break
      case "premios":
        return ResultadosApis.premiosApi
          break
      case "ramos":
        return ResultadosApis.ramosApi
          break
      case "retos":
        return ResultadosApis.retosApi
          break
      case "tipos-retos":
        return ResultadosApis.tiposRetosApi
          break
      case "tipos-actividades":
        return ResultadosApis.tiposActividadesApi
          break
      case "equivalencias":
        return ResultadosApis.equivalenciasApi
          break
      case "usuarios":
        return usuarioApi
          break
          
      case "productividad":
        return ResultadosApis.productividadApi
          break
      case "retoActividades":
        return ResultadosApis.retoActividadesApi
          break
      case "tiendaProductos":
        return ResultadosApis.tiendaProductosApi
          break
      case "progresoReto":
        return ResultadosApis.progresoRetoApi
          break
      case "productosAgente":
        return productosAgenteApi
          break
      case "compras":
        return comprasApi
          break
      case "progresoNivel":
        return ResultadosApis.progresoNivelApi
          break
      case "camino":
        return ResultadosApis.caminoApi
          break
      case "historial-equivalencias":
        return ResultadosApis.historialEquivalenciasApi
          break
      case "historial-progreso":
        return ResultadosApis.historialProgresoApi
          break
      case "schemasFormFactory":
        return schemaFormFactoryApi
          break
      case "permisos":
        return permisosApi
          break
      case "rutas":
        return rutasApi
          break
      case "tiposUsuario":
        return tiposUsuarioApi
          break
      case "reporteAxa":
        return reporteAxaApi
          break
    }
  }

  const [apiActiva, setApiActiva] = useState(getApiActiva())
  const [catalogo, setCatalogo] = useState([])
  const [loading, setloading] = useState(false)

  const load = async (filtros = {}, formatoCatalogo = {formatear: false, catalogoLabel: '', catalogoValue: ''}) => {
    //Carga la coleccion 
    //El segundo parametro se utiliza para darle formato de catalogo listo para un select a la coleccion 
    // catalogoLabel: es el nombre de la columna que se usara como label
    // catalogoValue: es el value de la columna que se usara como value
    setloading(true)
    filtros = { ...filtros }
    await apiActiva.load(filtros).then((res) => {
      const allData = formatoCatalogo.allData ?? false
        if (JSON.parse(JSON.stringify(res)).status === 200) {
            if (formatoCatalogo.formatear) {
                setCatalogo(extraerCatalogoDeColeccion(formatoCatalogo.catalogoLabel, formatoCatalogo.catalogoValue, res.data.data, allData))
            } else {
                setCatalogo(res.data.data)
            }
        } else {
          console.log(res.data.error)
        }
        setloading(false)
      })
      .catch((error) => {
        setloading(false)
        console.log(error)
      })
  }

  const customLoad = (filtros) => {
    //Carga la coleccion y retorna la promesa 
    filtros = { ...filtros }
    return apiActiva
      .load(filtros)
  }

  const onSuccess = (res, callback) => {
    setloading(false)
    if (JSON.parse(JSON.stringify(res)).status === 200) {
      callback(res)
    } else {
      console.log(res.data.error)
    }
  }

  const onFail = (error) => {
    setloading(false)
    console.log(error)
  }

  const handleAdministrarPromise = (responsePromise, callback) => {
    responsePromise
      .then((res) => {
        onSuccess(res, callback)
      })
      .catch((error) => {
        onFail(error)
      })
  }

  const agregarDatosAdicionales = (payload, user) => {
    if (payload instanceof FormData) {
      payload.append("idUsuario", user._id)
    } else {
      payload = {
        ...payload,
        idUsuario: user._id
      }
    }

    return payload
  }

  const administrar = async (payload, callback) => {
    getApiActiva()
    setloading(true)
    const user = JSON.parse(localStorage.getItem("userData"))
    payload = agregarDatosAdicionales(payload, user)
    apiActiva.admin(payload)
      .then((res) => {
        onSuccess(res, callback)
      })
      .catch((error) => {
        onFail(error)
      })
  }

  const customAdministrar = async (payload, callback) => {
    getApiActiva()
    setloading(true)
    apiActiva.admin(payload)
      .then((res) => {
        onSuccess(res, callback)
      })
      .catch((error) => {
        onFail(error)
      })
  }
  

  return {
    catalogo,
    loading,
    load,
    customLoad,
    customAdministrar,
    administrar
  }
}
